import { Checkbox } from '@cian/ui-kit';
import { ChangeEvent, FC, useCallback } from 'react';
import { useSelector } from 'react-redux';
import { useFilterChangeCallback } from 'shared/hooks';
import { selectHasPhotoFilter } from 'shared/selectors/advancedFilters';

export const HasPhotoContainer: FC = () => {
  const { label, value } = useSelector(selectHasPhotoFilter);

  const onChange = useFilterChangeCallback();

  const handleChange = useCallback(
    (_: ChangeEvent<HTMLInputElement>, newValue: boolean) => {
      onChange({ action: 'setHasPhoto', arguments: [newValue || null] });
    },
    [onChange],
  );

  return <Checkbox label={label} checked={value} onChange={handleChange} />;
};
